<script setup>

import {mdiTrashCanOutline} from "@mdi/js";
import {Link, router, usePage} from "@inertiajs/vue3";
import {hourglassEmpty} from "../../../assets/icons/icons.js";
import {inject} from "vue";
import {useSearchStore} from "./store/search.js";
import pinia from "../../../plugins/pinia.js";
const route = inject('route');
const emit = defineEmits(['closeOverlay']);
const searchStore = useSearchStore(pinia);

const search = (term) => {
    const model = {
        modelTypes: {
            id: term.models.id_model_type
        },
        brands: term.models.brand,
        cubatures: {
            cubature: term.models.cubature
        },
        models: term.models,
        years: term.year
    };

    router.post(route('eshop.setModelSearch'), {model: model, visit: true}, {
        preserveScroll: true,
        preserveState: false,
        onSuccess: (response) => {
            emit('closeOverlay');
            setTimeout(() => {
                searchStore.setSelected(model.type, model.brand, { cubature: model.cubature }, {
                    name: model.name,
                    id: model.id,
                });
            }, 200);
            if (usePage().component === '@Module::eshop-Group') {
                if (!usePage().url.includes('/model/')) {
                    router.reload()
                }
            }
        }
    })
}
</script>

<template>
    <v-divider color="grey-lighten-2"></v-divider>
    <v-card elevation="0" :rounded="$vuetify.display.mdAndUp ? 'lg' : 0" class="rounded-t-0">
        <v-card-text>
            <div class="px-2 py-4 px-md-8 py-md-4">
                <v-row>
                    <v-col cols="12" md="6">
                        <div class="d-flex align-center ga-4">
                            <v-icon :size="24" color="cis-accent-color" v-if="$vuetify.display.mdAndUp" :icon="hourglassEmpty"></v-icon>
                            <h3 class="text-claims text-md-h6 font-weight-black">{{$t('homepage-combined.last_searched')}}</h3>
                            <v-spacer></v-spacer>
                            <v-btn v-if="$vuetify.display.mdAndUp" @click="() => { router.delete(route('customer.removeSearched')); emit('closeOverlay'); }" variant="text" class="text-tiny-link font-weight-regular text-decoration-underline" :prepend-icon="mdiTrashCanOutline">
                                {{$t('homepage-combined.delete_history')}}
                            </v-btn>
                            <v-btn v-else @click="() => { router.delete(route('customer.removeSearched')); emit('closeOverlay'); }" variant="text" class="text-tiny-link font-weight-regular text-decoration-underline" :icon="mdiTrashCanOutline"></v-btn>
                        </div>
                        <v-list>
                            <v-list-item v-for="term in $page.props.searchedBikes" class="px-1 clickable-link text-body-3">
                                <a class="text-decoration-underline cursor-pointer" @click="search(term)">{{ term.models.brand?.name }} {{ term.models.name }} ({{ term.year }})</a>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-col v-if="$vuetify.display.mdAndUp"></v-col>
                </v-row>
            </div>
        </v-card-text>
    </v-card>
</template>

<style scoped lang="scss">
@use '../../../plugins/vuetify-settings' as *;
@use 'sass:map';
.clickable-link {
    border-bottom: 1px solid map.get($grey, lighten-2);
    a {
        text-decoration: underline;
        cursor: pointer;
        &:hover {
            color: map.get($orange, base);
            text-decoration: none;
        }
    }
}
</style>
